import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogoWordmark } from "@/components/Logo";
import { LockKey } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.success) {
      toast.success("Connexion réussie");
      navigate("/admin", { replace: true });
    } else {
      toast.error(r.error || "Identifiants invalides");
    }
  };

  const inputCls = "w-full bg-ducs-night border border-ducs-gold/25 px-4 py-3 text-ducs-cream focus:border-ducs-gold rounded-sm";

  return (
    <div className="min-h-screen bg-ducs-night flex items-center justify-center px-5">
      <div className="absolute inset-0 dijon-pattern opacity-30" aria-hidden />
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="relative w-full max-w-md card-ducs p-8"
      >
        <Link to="/" className="flex justify-center mb-6">
          <LogoWordmark />
        </Link>
        <div className="text-center mb-8">
          <LockKey size={26} className="text-ducs-gold mx-auto" />
          <h1 className="font-serif text-2xl text-ducs-cream mt-3">Espace administration</h1>
          <p className="text-sm text-ducs-mist mt-2">Accès réservé</p>
        </div>
        <div className="space-y-5">
          <div>
            <label className="label-caps block mb-2" htmlFor="login-email">Email</label>
            <input
              id="login-email" type="email" required data-testid="login-email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className={inputCls}
            />
          </div>
          <div>
            <label className="label-caps block mb-2" htmlFor="login-password">Mot de passe</label>
            <input
              id="login-password" type="password" required data-testid="login-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className={inputCls}
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={busy}
          data-testid="login-submit"
          className="btn-primary w-full mt-8 disabled:opacity-60"
        >
          {busy ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
